// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Caml_array = require("rescript/lib/js/caml_array.js");
var Js_promise = require("rescript/lib/js/js_promise.js");
var Caml_format = require("rescript/lib/js/caml_format.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Webapi__Fetch = require("rescript-webapi/src/Webapi/Webapi__Fetch.res.js");
var JsxRuntime = require("react/jsx-runtime");
var Utils$ReactHooksTemplate = require("../common/utils.res.js");

function getInputValue(x) {
  return x._0;
}

function getValidationError(x) {
  switch (x.TAG) {
    case "Invalid" :
        return x._1;
    case "Valid" :
    case "Pristine" :
        return /* [] */0;
    
  }
}

function validFormInput(x) {
  switch (x.TAG) {
    case "Valid" :
        return true;
    case "Invalid" :
    case "Pristine" :
        return false;
    
  }
}

function validForm(form) {
  if (validFormInput(form.name) && validFormInput(form.campaignId)) {
    return validFormInput(form.file);
  } else {
    return false;
  }
}

function validFileSize(file) {
  return file.size < 5242880;
}

function DistributionCreate(props) {
  var toggleDistributionCreate = props.toggleDistributionCreate;
  var emptyState_name = {
    TAG: "Valid",
    _0: ""
  };
  var emptyState_campaignId = {
    TAG: "Valid",
    _0: Caml_format.int_of_string(props.campaignId)
  };
  var emptyState_file = {
    TAG: "Pristine",
    _0: undefined
  };
  var emptyState = {
    name: emptyState_name,
    campaignId: emptyState_campaignId,
    file: emptyState_file
  };
  var match = React.useState(function (param) {
        return emptyState;
      });
  var setState = match[1];
  var state = match[0];
  var handleFileChange = function ($$event) {
    var file = Caml_array.get($$event.target.files, 0);
    if (file.size < 5242880) {
      return Curry._1(setState, (function (state) {
                    return {
                            name: state.name,
                            campaignId: state.campaignId,
                            file: {
                              TAG: "Valid",
                              _0: file
                            }
                          };
                  }));
    } else {
      return Curry._1(setState, (function (state) {
                    return {
                            name: state.name,
                            campaignId: state.campaignId,
                            file: {
                              TAG: "Invalid",
                              _0: file,
                              _1: {
                                hd: "File size should be less\n    than 5 MB",
                                tl: /* [] */0
                              }
                            }
                          };
                  }));
    }
  };
  var handleFormSubmit = function ($$event) {
    $$event.preventDefault();
    var formData = new FormData();
    var file = state.file._0;
    if (file !== undefined) {
      formData.append("distribution[customer_source_attributes][file]", Caml_option.valFromOption(file), undefined);
    }
    formData.append("distribution[customer_source_type]", "FeedFile");
    formData.append("distribution[customer_source_attributes][name]", state.name._0);
    Js_promise.then_((function (response) {
            Curry._1(toggleDistributionCreate, "save");
            return Promise.resolve(response.json());
          }), fetch("/api/v1/campaigns/" + (String(state.campaignId._0) + "/distributions"), Webapi__Fetch.RequestInit.make("Post", [
                  [
                    "X-CSRF-TOKEN",
                    Utils$ReactHooksTemplate.csrfToken
                  ],
                  [
                    "Accept",
                    "*"
                  ]
                ], Caml_option.some(formData), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)));
  };
  var match$1 = state.file;
  var tmp;
  switch (match$1.TAG) {
    case "Invalid" :
        tmp = $$Array.of_list(Belt_List.mapWithIndex(match$1._1, (function (i, e) {
                    return JsxRuntime.jsx("p", {
                                children: e,
                                className: "text-red-500 font-medium float-right"
                              }, String(i));
                  })));
        break;
    case "Valid" :
    case "Pristine" :
        tmp = JsxRuntime.jsx(JsxRuntime.Fragment, {});
        break;
    
  }
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsxs("form", {
                    children: [
                      JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx("div", {
                                    children: JsxRuntime.jsx("div", {
                                          children: "General Settings",
                                          className: "px-6 py-5 bg-lavenderweb"
                                        }),
                                    className: "w-3/10 flex flex-col border-r border-gray-300\n                        text-darkcharcoal text-base"
                                  }),
                              JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsx("div", {
                                                    children: "File Upload",
                                                    className: "text-sm font-medium"
                                                  }),
                                              JsxRuntime.jsx("div", {
                                                    children: JsxRuntime.jsx("input", {
                                                          className: "h-10 w-3/4 block border px-3 py-2 border-gray-400\n                           bg-white rounded capitalize text-sm cursor-pointer ",
                                                          accept: ".csv",
                                                          type: "file",
                                                          onChange: handleFileChange
                                                        }),
                                                    className: "w-2/3"
                                                  })
                                            ],
                                            className: "flex justify-between items-center"
                                          }),
                                      JsxRuntime.jsx("div", {
                                            children: tmp
                                          })
                                    ],
                                    className: "w-7/10 flex flex-col p-8"
                                  })
                            ],
                            className: "flex h-96 z-20 relative"
                          }),
                      JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx("button", {
                                    children: "Discard",
                                    className: "bg-ghostwhite border border-gray-400\n          flex rounded py-3 px-6 text-xs",
                                    id: "close_modal",
                                    onClick: (function (param) {
                                        Curry._1(toggleDistributionCreate, "close");
                                      })
                                  }),
                              JsxRuntime.jsx("input", {
                                    className: "bg-palatinateblue border border-gray-400\n          flex rounded py-3 px-6 text-xs text-white",
                                    disabled: !validForm(state),
                                    type: "submit",
                                    value: "Save"
                                  })
                            ],
                            className: "p-8 flex border-t border-gray-200 justify-end gap-3 font-medium\n        absolute bottom-0 text-base w-full z-30 relative"
                          })
                    ],
                    onSubmit: handleFormSubmit
                  })
            });
}

var make = DistributionCreate;

exports.getInputValue = getInputValue;
exports.getValidationError = getValidationError;
exports.validFormInput = validFormInput;
exports.validForm = validForm;
exports.validFileSize = validFileSize;
exports.make = make;
/* react Not a pure module */
